<template>
  <div
    ref="bannerSize"
    class="banner-container"
  >
    <!-- 背景图 -->
    <img
      class="banner-bg"
      src="@/assets/home/banner.png"
    >
    <img
      class="man"
      src="@/assets/home/man_1@2x.png"
    >
    <Logo />
    <Robot />
    <Dotlist :products="products" />
    <BannerTooltip
      v-for="(product, index) in products"
      :key="index"
      :product="product"
      :delay-time="200"
    />
  </div>
</template>

<script>

import Dotlist from '@/components/Banner/Dotlist.vue';
import BannerTooltip from '@/components/Banner/Tooltip.vue';
import Logo from '@/components/Banner/Logo.vue';
import Robot from '@/components/Banner/Robot.vue';

export default {
  name: 'Banner',
  components: {
    Dotlist, BannerTooltip, Logo, Robot,
  },
  data() {
    return {
      products: [{
        x: 25,
        y: 36,
        title: '智能背包',
        isInside: false,
        url: 'https://www.royole.com/smart-backpack',
        image: require('@/assets/product/rowrite.png'),
      },
      {
        x: 39.4,
        y: 35.7,
        title: '智能键盘',
        isInside: false,
        url: 'https://www.royole.com/auto-retracting-transparent-keyboard',
      }, {
        x: 49,
        y: 34,
        title: '白柔记',
        isInside: true,
        url: 'http://purchase.royole.com/product?product_id=85',
      }, {
        x: 52,
        y: 63,
        title: 'Royole Moon',
        isInside: true,
        url: 'http://purchase.royole.com/product?product_id=55',
      }, {
        x: 62.2,
        y: 55.5,
        title: 'Flexpai柔派',
        isInside: true,
        url: 'http://purchase.royole.com/product?product_id=86',
      }, {
        x: 66.9,
        y: 66.5,
        title: '千寻台灯',
        isInside: true,
        url: 'http://purchase.royole.com/product?product_id=84',
      }, {
        x: 70.5,
        y: 53,
        title: '柔性屏时尚上衣',
        isInside: true,
        url: 'http://purchase.royole.com/product?product_id=91',
      }, {
        x: 73,
        y: 48,
        title: '柔性屏时尚礼帽',
        isInside: true,
        url: 'http://purchase.royole.com/product?product_id=90',
      }, {
        x: 73.8,
        y: 1,
        title: '自拍杆',
        isInside: false,
        url: '待补充',
      }],
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/utils.scss';
.banner-container {
  position: relative;
  background-repeat: no-repeat;
  width: 100%;
  min-width: 1360px;
  font-size: 0;
  .banner-bg {
    width: 100%;
  }
  .man {
    z-index: 2;
    position: absolute;
    top: 11%;
    left: 28.5%;
    width: widthToPerc(225);
    height: heightToPerc(546);
  }
}
</style>
